import * as React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router';
import { rem } from 'polished';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { DsiOrderDetailItems as OrderDetailItems } from './OrderDetailItems';
import { getOrderDetailInfo } from '../../../../utilities/selectors';
import { Button } from '../../../Zemplin/General/Button';
import { DsiSummaryValue as SummaryValue } from '../../Cart/Summary/SummaryValue';
import { formatPrice, formatPriceToString, prop } from '../../../../utilities';
import { TextP } from '../../../../index';
import { DsiBaseOptions as BaseOptions } from './BaseOptions';
import { DsiPaymentOptions as PaymentOptions } from './PaymentOptions';
import { DsiContactOptions as ContactOptions } from './ContactOptions';
import { DsiAddress as Address } from './Address';
import { FinalValue } from '../../Cart/Summary/FinalValue';

interface Props {
  data: any;
  user: any;
}

function OrderDetail({ user, data }: Props) {
  const {
    orderNr,
    orderStatusReadable,
    items,
    totalPrice,
    totalPriceWithoutVat,
    currency,
    vatRate,
    vat,
    phone,
    email,
    company,
    street,
    streetNr,
    city,
    zip,
    deliveryCompany,
    deliveryStreet,
    deliveryStreetNr,
    deliveryCity,
    deliveryZip,
    deliveryType,
    deliveryPrice,
    paymentType,
    discount,
    invoiceLink,
    itemsPriceWithoutVat,
    deliveryPriceWithoutVat,
    note,
    customOrderNr,
    totalItemsPrice,
  } = getOrderDetailInfo(data);
  const hasDiscount = discount && discount !== 0;

  const isB2b = !!(user && user.b2b);
  return (
    <>
      <Wrapper>
        <LeftSide>
          <OrderDetailPart>
            <BaseOptions
              orderNr={prop(data, 'outer_id')}
              state={orderStatusReadable}
              price={totalPrice}
              currency={currency}
              paymentState={
                prop(data, 'order_paid_datetime')
                  ? __('Uhradená')
                  : __('Neuhradená')
              }
              note={note}
              customOrderNr={customOrderNr}
            />
          </OrderDetailPart>
          {/* <OrderDetailPart>
          <ContactOptions phoneNr={phone} email={email} />
        </OrderDetailPart> */}
          <FlexRowCenterVertical>
            {isB2b && (
              <OrderDetailPart marginRight={16}>
                <Address
                  title={`${__('Fakturačná adresa')}`}
                  company={company}
                  street={street}
                  streetNr={streetNr}
                  city={city}
                  psc={zip}
                />
              </OrderDetailPart>
            )}
            <OrderDetailPart>
              <Address
                title={`${__('Dodacia adresa')}`}
                company={deliveryCompany}
                street={deliveryStreet}
                streetNr={deliveryStreetNr}
                city={deliveryCity}
                psc={deliveryZip}
              />
            </OrderDetailPart>
          </FlexRowCenterVertical>
          <OrderDetailPart>
            <PaymentOptions
              title={`${__('Dodacie a platobné podmienky')}`}
              delivery={deliveryType}
              payMethod={paymentType}
              payback={'30 dní'}
              currency={currency}
              credit={'9 999,00'}
              freeCredit={'9 999,00'}
            />
          </OrderDetailPart>
        </LeftSide>
        <Summary>
          <Subtitle marginBottom={32}>{`${__('Sumarizácia')}`}</Subtitle>
          <SummaryValue
            title={__('Cena tovaru')}
            value={formatPrice(
              prop(totalItemsPrice, 'priceWithoutVat'),
              currency,
            )}
            borderBottom={!hasDiscount ? true : false}
          />
          {/* {hasDiscount ? (
          <SummaryValue
            title={__('Zľava -10 %')}
            value={formatPrice(discount, currency)}
            borderBottom={true}
          />
        ) : (
          ''
        )} */}
          {!!deliveryType && (
            <SummaryValue
              title={deliveryType}
              value={formatPrice(deliveryPriceWithoutVat, currency)}
              borderBottom={true}
            />
          )}
          {/* <SummaryValue
          title={__(`Základ dane pre ${vatRate} %`)}
          value={formatPrice(totalPriceWithoutVat, currency)}
        />
        <SummaryValue
          title={__(`DPH ${vatRate} %`)}
          value={formatPrice(vat, currency)}
        />
        <SummaryValue
          title={__('Cena s DPH')}
          value={formatPrice(totalPrice, currency)}
          borderBottom={true}
        /> */}
          <FinalValue
            title={__('Spolu')}
            value={formatPrice(totalPrice, currency)}
          />
          {/* <StyledButton>
          <StyledLink to={invoiceLink}>
            <BtnText>{`${__('Stiahnúť (.pdf)')}`}</BtnText>
          </StyledLink>
        </StyledButton> */}
        </Summary>
      </Wrapper>

      <OrderDetailPart>
        <Subtitle>{`${__('Objednaný tovar')}`}</Subtitle>
        <OrderDetailItems isB2B={user && user.b2b} items={items} />
      </OrderDetailPart>
    </>
  );
}
const Wrapper = styled(FlexRow)`
  width: 100%;
  margin-right: 0;

  ${({ theme }) => theme.mediab.l1150`
    flex-flow: row wrap;
  `}

  ${({ theme }) => theme.mediab.l925`
    padding-top: ${rem(32)};
  `}
`;

const OrderDetailPart = styled.div<{ marginRight?: number }>`
  width: 100%;
  padding: ${rem(32)};
  border-radius: ${rem(4)};
  border: ${({ theme }) => theme.borders.primary};
  margin-bottom: ${rem(16)};
  margin-right: ${({ marginRight }) => (marginRight ? rem(marginRight) : 0)};
`;

export const Subtitle = styled.h2<{ marginBottom?: number }>`
  font-size: ${rem(24)};
  font-weight: 500;
  margin-top: 0;
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? rem(marginBottom) : 0};
`;

const Summary = styled(OrderDetailPart)`
  display: flex;
  width: 100%;
  max-width: ${rem(464)};
  background-color: ${({ theme }) => theme.colors.white};
  flex-direction: column;
  margin: 0;
  height: fit-content;
`;

const LeftSide = styled(FlexCol)`
  width: 100%;
  margin-right: ${rem(16)};
`;

const StyledButton = styled(Button)`
  width: 100%;
  height: ${rem(56)};
  background-color: ${({ theme }) => theme.colors.white};
  margin-top: ${rem(16)};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border: 2px solid rgba(30, 57, 141, 0.12);
  border-radius: ${rem(4)};
  text-decoration: none;
`;

const BtnText = styled(TextP)`
  width: 100%;
  text-align: center;
  font-weight: 500;
  font-size: ${rem(16)};
  text-decoration: none;
`;

const StyledLink = styled(Link)`
  width: 100%;
  text-decoration: none;
`;

export { OrderDetail as DsiOrderDetail };
